import React, { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import NotFoundPage from "./NotFoundPage";
import { Loader } from "../layout/Loader";

const HomePage = lazy(() => import("../home/HomePage"));
const LoginPage = lazy(() => import("../login/LoginPage"));
const DashboardRoot = lazy(() => import("../dashboard/DashboardRoot"));

export default function AppRoot(): JSX.Element {
  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <React.Suspense fallback={<Loader />}>
              <HomePage />
            </React.Suspense>
          }
        />
        <Route
          path="/login"
          element={
            <React.Suspense fallback={<Loader />}>
              <LoginPage />
            </React.Suspense>
          }
        />
        <Route
          path="/dashboard/*"
          element={
            <React.Suspense fallback={<Loader />}>
              <DashboardRoot />
            </React.Suspense>
          }
        />
        <Route path="/*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}
